/* --------------------------------------------------------------------------
	Microsite Header
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	function init() {
		if (!$('.js-micro-page-header-video').length) {
			return;
		}

		$('.js-micro-page-header-pause').on('click', onPauseClick);
		$('.js-micro-page-header-play').on('click', onPlayClick);
	}

	function onPauseClick() {
		$('.js-micro-page-header-video').trigger('pause');
		$('.js-micro-page-header-pause').removeClass('active');
		$('.js-micro-page-header-play').addClass('active');
	}

	function onPlayClick() {
		$('.js-micro-page-header-video').trigger('play');
		$('.js-micro-page-header-play').removeClass('active');
		$('.js-micro-page-header-pause').addClass('active');
	}

	Site.OnInit.push(init);
})(jQuery, Site);
